import { GET_CMS, UPDATE_CMS, VIEW_CMS } from 'store/actions/pages';

const initialState = {
  isAuthenticated: false,
  loader:false,
  cmsList:[],
  cmsDetail:{}
};

const getCms = (state, payload) => {
    const { callback } = payload;
    if (typeof callback === 'function') {
      callback(payload);
    }
    const stateObj = {
      ...state,
      isAuthenticated: true,
      cmsList:payload,
    };
    return stateObj;
};

const updateCms = (state, payload) => {
  const { callback } = payload;
  if (typeof callback === 'function') {
    callback(payload);
  }
  const stateObj = {
    ...state,
    isAuthenticated: true,
    cmsList:payload,
  };
  return stateObj;
};

const viewCms = (state, payload) => {
  const { callback } = payload;
  if (typeof callback === 'function') {
    callback(payload);
  }
  const stateObj = {
    ...state,
    isAuthenticated: true,
    cmsDetail:payload,
  };
  return stateObj;
};

const Pages = (state = initialState, { type, payload = null }) => {
    switch (type) {
        case GET_CMS:
          return getCms(state, payload); 
        case UPDATE_CMS:
          return updateCms(state, payload); 
        case VIEW_CMS:
          return viewCms(state, payload); 
        default:
        return state;
    };
}
export default Pages;
